interface WizardModeToggleProps {
  mode: 'guided' | 'form'
  onChange: (mode: 'guided' | 'form') => void
}

export function WizardModeToggle({ mode, onChange }: WizardModeToggleProps) {
  return (
    <div className="flex gap-1 p-1 rounded-full bg-canvas shrink-0" role="group" aria-label="Form mode">
      {(['guided', 'form'] as const).map((m) => {
        const active = mode === m
        return (
          <button
            key={m}
            type="button"
            onClick={() => onChange(m)}
            aria-pressed={active}
            className="px-4 py-2 rounded-full text-[13px] font-semibold border-0 cursor-pointer font-sans transition-all duration-200"
            style={{
              background: active ? 'var(--surface)' : 'transparent',
              color: active ? 'var(--ink)' : 'var(--muted)',
              boxShadow: active ? '0 1px 4px rgba(31,26,46,.10)' : 'none',
            }}
          >
            {m === 'guided' ? 'Guided' : 'Just the form'}
          </button>
        )
      })}
    </div>
  )
}
